module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"Cerrar":"Cerrar"},"en":{},"ca":{"Cerrar":"Tancar"}}')
  delete Component.options._Ctor
}
